export enum TipoFilterEnum {
  AREA_COMUM = "areaComum",
  CONTA = "conta",
  ESTACIONAMENTO = "estacionamento",
  INTEGRADOR = "integrador",
  TODOS = "todos",
  UNIDADE = "unidade",
  MORADOR = "morador",
  VEICULO = "veiculo",
  FORNECEDOR = "fornecedor",
  MODO_DEBUG = "modoDebug"
}
